import { getUserUuidFromToken } from "./tokenStorage";

const KEY = "chat:userId";

export function getOrCreateUserId() {
    const tokenUuid = getUserUuidFromToken();
    if (tokenUuid) {
        localStorage.setItem(KEY, tokenUuid);
        return tokenUuid;
    }

    let id = localStorage.getItem(KEY);
    if (id) return id;

    id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now());
    localStorage.setItem(KEY, id);
    return id;
}

// remove, just for testing
export function resetUserId() {
    const id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now());
    localStorage.setItem(KEY, id);
    return id;
}

export function removeUserId() {
    localStorage.removeItem(KEY);
}
